import { render, staticRenderFns } from "./LoadingFrames.vue?vue&type=template&id=1a662618&scoped=true"
import script from "./LoadingFrames.vue?vue&type=script&lang=js"
export * from "./LoadingFrames.vue?vue&type=script&lang=js"
import style0 from "./LoadingFrames.vue?vue&type=style&index=0&id=1a662618&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a662618",
  null
  
)

export default component.exports